import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { API_ENDPOINT } from './../_config/config';

export type DeletedEntity = 'partners' | 'customers' | 'users' | 'projects' | 'tags';

/** A soft-deleted record; besides these it carries its entity's own fields (ids of its references) */
export interface DeletedRecord {
    id: string;
    deletedAt: string;
    deletedBy: string;
    deletedByEmail?: string;
    /** partners, customers, projects and tags */
    name?: string;
    /** users */
    email?: string;
    role?: string;
    /** tags */
    color?: string;
    /** partners */
    uri?: string;
    /** ids of what the record belongs to (customers, users, projects and tags) */
    partner?: string;
    customer?: string;
    project?: string;
    /** names of what the record belonged to, deleted or not */
    partnerName?: string;
    customerName?: string;
    projectName?: string;
}

/** What a permanent delete also removes: counted for partners and customers */
export interface DeletedImpact {
    customers?: number;
    projects?: number;
    users?: number;
}

/** Superadmin only: soft-deleted records, to restore or delete for good */
@Injectable({
    providedIn: 'root'
})
export class DeletedService {
    constructor(private http: HttpClient) { }

    /** An entity's soft-deleted records, newest deletion first */
    list(entity: DeletedEntity) {
        return this.http.get<{ records: DeletedRecord[], count: number }>(`${API_ENDPOINT}/deleted/${entity}`);
    }

    impact(entity: DeletedEntity, id: string) {
        return this.http.get<{ impact: DeletedImpact }>(`${API_ENDPOINT}/deleted/${entity}/${id}/impact`);
    }

    restore(entity: DeletedEntity, id: string) {
        return this.http.post<{ message: string }>(`${API_ENDPOINT}/deleted/${entity}/${id}/restore`, null);
    }

    /** Delete a soft-deleted record for good, with everything it owns; the API wants the id repeated */
    hardDelete(entity: DeletedEntity, id: string) {
        return this.http.delete<{ message: string }>(`${API_ENDPOINT}/deleted/${entity}/${id}`, { body: { confirmId: id } });
    }
}
